import { useCallback, useMemo, useState } from "react";

import { useObjectMemo } from "../../../hooks";

import { directDepositEnrollmentForm } from "./form";

import type { ReactLocalization } from "@fluent/react";

export const useDirectDepositManualForm = () => {
  const form = directDepositEnrollmentForm.useForm();
  // To-do - send API request on success https://linear.app/narmi/issue/CDB-833
  return useObjectMemo({ form });
};

export const useSensitiveDataDisplay = (l10n: ReactLocalization) => {
  const [isMasked, setIsMasked] = useState(true);
  const toggleMaskedState = () => setIsMasked((prev) => !prev);

  const formatSensitiveData = useCallback(
    (data: string | undefined) => {
      if (isMasked) {
        return "*********";
      }

      return data;
    },
    [isMasked],
  );

  const iconForShowHideButton = useMemo(
    () => (isMasked ? "eye" : "eye-off"),
    [isMasked],
  );

  const labelForShowHideButton = useMemo(
    () =>
      isMasked
        ? l10n.getString("direct-deposit-manual-form-show-info")
        : l10n.getString("direct-deposit-manual-form-hide-info"),
    [isMasked, l10n],
  );

  return useObjectMemo({
    isMasked,
    toggleMaskedState,
    formatSensitiveData,
    iconForShowHideButton,
    labelForShowHideButton,
  });
};
